import { useSelector } from 'react-redux';

import { openSyncBranchDialog } from 'src/redux/branches';
import { refreshCodeReviewData } from 'src/redux/pull-request/actions';
import {
  getConflictStatus,
  getDestinationBranchName,
  getPullRequestBranchName,
  getPullRequestDestinationRepo,
  getPullRequestSourceRepo,
  getPullRequestSourceHash,
  getPullRequestDestinationHash,
} from 'src/redux/pull-request/selectors';
import { getBranchSyncInfo } from 'src/redux/repo-commits/selectors';
import { BranchSyncInfoProps } from 'src/sections/repository/components/commit-list/branch-sync-info';
import { getCurrentRepositorySshCloneLink } from 'src/selectors/repository-selectors';

export const usePullRequestBranchSyncInfoDetails = (): BranchSyncInfoProps => {
  const destinationRepository = useSelector(getPullRequestDestinationRepo);
  const sourceRepository = useSelector(getPullRequestSourceRepo);
  const branchSyncInfo = useSelector(getBranchSyncInfo);
  const sourceHash = useSelector(getPullRequestDestinationHash) || '';
  const destinationHash = useSelector(getPullRequestSourceHash) || '';
  // destination and source branches were changed intentionally
  // because destination branch of PR is actually a source branch
  // to sync data from
  const destinationBranchName = useSelector(getPullRequestBranchName);
  const sourceBranchName = useSelector(getDestinationBranchName);
  const hasConflicts = useSelector(getConflictStatus);
  const sourceCloneLink = useSelector(getCurrentRepositorySshCloneLink);
  const reloadAction = refreshCodeReviewData({
    needsDiff: true,
    needsComments: false,
    needsTasks: false,
    needsPullRequest: true,
  });

  return {
    destinationRepositoryFullName: sourceRepository?.full_name || '',
    sourceRepositoryFullName: destinationRepository?.full_name || '',
    branchSyncInfo,
    sourceHash,
    destinationHash,
    destinationBranchName,
    sourceBranchName,
    hasConflicts,
    sourceCloneLink: sourceCloneLink || '',
    openSyncDialog: openSyncBranchDialog,
    reloadAction,
  };
};
